<template>
  <div class="img-wrap">
    <div class="img-group" v-if="params.uploadType == 2">
      <div class="img-item" v-for="(item,index) in picList" :key="index">
        <img :src="item.url" @click="toPreview(index)" class="uploadImg">
        <img src="@/assets/images/m-report/close-icon.png" class="closeImg" @click='delImg(item.key)'>
      </div>
      <div class="img-item pic-add" v-show="picList.length < params.limitCount">
        <img src="@/assets/images/m-report/add-file.png" class="add-icon">
        <input type="file" class="input-upload" @change="addFile" ref="inputer" multiple
            :accept="accept" />
      </div>
      <div class="empty"></div>
      <div class="empty"></div>
      <div class="empty"></div>
      <div class="empty"></div>
    </div>
    <div class="group-pdf img-group" v-else>
      <div class="img-item pic-add" v-if="!fileData.name">
        <img src="@/assets/images/m-report/add-file.png" class="add-icon">
        <input type="file" class="input-upload" @change="addFile" ref="inputer"
            :accept="accept" />
      </div>
      <div class="pdf-wrap" v-else>
        <img class="pdf-icon" src="@/assets/images/m-report/pdf-file.png">
        <img class="close-img" src="@/assets/images/m-report/close-icon.png" @click='delUpload'>
        <div class="pdf-info">
          <p class="name">{{ fileData.name }}</p>
          <p class="time">{{ fileData.time }}上传</p>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script type="text/javascript">
import { Toast, ImagePreview } from 'vant'
import { getYMDString } from "@/assets/js/until.js";
export default {
  name: "Upload",
  data() {
    return {
      formData: new FormData(),
      fileList: {},
      fileData: {},
      fileLen: 0,
      size: 5,
    };
  },
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          key: "license",
          size: 10,
          limitCount: 20,
          uploadType: 2,
          type: ["jpg", "jpeg", "png"]
        };
      },
    },
    accept: {
      type: String,
      default: "image/png,image/jpeg,image/jpg",
    },
  },
  watch: {
    'params.uploadType'(uploadType) {
      this.fileLen = 0;
      this.fileData = {};
      this.fileList = {}
    }
  },
  computed: {
    picList() {
      let urlList = []
      for (let key in this.fileList) {
        urlList.push({
          url: this.getObjectURL(this.fileList[key]),
          key: key,
        })
      }
      return urlList.slice(0,20)
    }
  },
  methods: {
    /**
     * @description: 选择图片或pdf文件
     * @*params: 
     * @param {*} event
     */
    addFile(event) {
      let inputDOM = this.$refs.inputer;
      this.fil = inputDOM.files;
      if((this.fil.length + this.picList.length) > this.params.limitCount) {
        let msg = this.params.uploadType == 2 ? `图片最多上传${this.params.limitCount}张` : `PDF文件仅限上传${this.params.limitCount}份`
        Toast(msg);
        return false
      }
      for (let i = 0; i < this.fil.length; i++) {
        let file = this.fil[i];
        let size = Math.floor(file.size / 1024);
        if (size > this.size * 1024 * 1024) {
          Toast(`请选择${params.size}以内的${this.params.uploadType == 2 ? '图片' : '文件'}！`);
          return false
        }
        if(this.params.uploadType == 1) {
          if (!this.checkType(file)) {
            Toast(`请上传PDF格式文件`);
            return false;
          }
          this.$set(this.fileData,'time',getYMDString(new Date()));
          this.$set(this.fileData,'name',file.name);
          this.$set(this.fileData,'file',file);
        }else{
          if (!this.checkType(file)) {
            Toast(`请上传jpg,jpeg,png格式图片`);
            return false;
          }
          this.$set(this.fileList, this.fil[i].name + '?' + new Date().getTime(), this.fil[i]);
        }
      }
      console.log(this.fileData)
      this.$emit("receive", {
        key: this.params.key,
        value: this.params.uploadType == 2 ? this.getFileList() : this.fileData.file,
      });
      event.target.value = '';
    },
    /**
     * @description: 校验文件格式
     * @*params: file 文件信息
     * @param {*} event
     */
    checkType(file) {
      var flag = false;
      for (var i in this.params.type) {
        if (file.type.indexOf(this.params.type[i]) > -1) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    /**
     * @description: url格式转化
     * @*params: file 文件流
     * @param {*} event
     */
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) { // basic
          url = window.createObjectURL(file);
      } else if (window.URL != undefined) { // mozilla(firefox)
          url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
     /**
     * @description: 表单数据格式化
     * @*params: 
     * @param {*} event
     */
    getFileList() {
      let list = []
      Object.keys(this.fileList).forEach((key,index) => {
        list.push({
          picFile: this.fileList[key],
          poi: index+1,
        })
      })
      return list
    },
    /**
     * @description: 图片清除某一项
     * @*params: key 图片key
     * @param {*} event
     */
    delImg(key) {
      this.$delete(this.fileList, key);
      this.$emit("receive", {
        key: this.params.key,
        value: this.getFileList(),
      });
      console.log(this.getFileList())
    },
    /**
     * @description: pdf清除某一项
     * @*params: 
     * @param {*} event
     */
    delUpload() {
      this.fileData = {};
      this.$emit("receive", {
        key: this.params.key,
        value: null,
      });
    },
    /**
     * @description: 图片预览
     * @*params: 
     * @param {*} event
     */
    toPreview(index) {
      let url = [];
      this.picList.forEach(item => {
        url.push(item.url)
      })
      ImagePreview({
        images: url,
        startPosition: index,
      })
    }
  },
  created() {

  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/function.scss";

.img-group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  .empty {
    width: getsize(145px);
    height: 0;
    visibility: hidden;
  }
  .img-item {
    position: relative;
    width: getsize(145px);
    height: getsize(145px);
    margin: 0 getsize(35px) getsize(28px) 0;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.pic-add {
      background: rgba(240,240,240,0.3);
      border-radius: getsize(14px);
      .add-icon {
        position: absolute;
        top: getsize(44px);
        left: getsize(44px);
        width: getsize(54px);
        height: getsize(54px);
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .closeImg {
      position: absolute;
      top: getsize(-8px);
      left: getsize(-8px);
      width: getsize(36px);
      height: getsize(36px);
    }
  }
  .input-upload{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    font-size: 0;
  }
  .pdf-wrap {
    position: relative;
    width: 100%;
    height: getsize(120px);
    background: #FFFFFF;
    box-shadow: 0px 0px getsize(8px) 0px rgba(0,0,0,0.1);
    border-radius: getsize(20px);
    padding: getsize(18px) 0 0 getsize(32px);
    box-shadow: border-box;
    display: flex;
    margin-top: getsize(10px);
    .pdf-icon {
      width: getsize(69px);
      height: getsize(78px);
      margin-right: getsize(40px);
    }
    .name {
      font-size: getsize(26px);
      color: #333333;
      margin-bottom: getsize(8px);
    }
    .time {
      font-size: getsize(22px);
      color: #999999;
    }
    .close-img {
      position: absolute;
      top: getsize(-18px);
      right: getsize(-18px);
      width: getsize(36px);
      height: getsize(36px);
    }
  }
}
</style>
